<template>
  <main style="height: 100%">
    <router-view />
  </main>
</template>
<script setup lang="ts">
</script>
